type ChangeRatingCoeffTextProps = {
  /** Rating change coefficient (Figma `change_rating_coeff_text`). */
  value?: string;
};

const DEFAULT_VALUE = '+0,1';

/** Figma `change_rating_coeff_text` (104:24632) — Matias 30.943. */
export function ChangeRatingCoeffText({
  value = DEFAULT_VALUE,
}: ChangeRatingCoeffTextProps) {
  return (
    <svg
      className="rating-screen-button__change-coeff"
      width={46}
      height={37}
      viewBox="0 0 46 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <text
        className="rating-screen-button__change-coeff-text"
        xmlSpace="preserve"
      >
        <tspan x={0} y={28}>
          {value}
        </tspan>
      </text>
    </svg>
  );
}
